"use client";

import React from "react";
import VadImage from "vadimages-nextjs-image-optimizer";
import { useReveal } from "@/components/Reveal/useReveal";

interface InplaceVideoProps extends React.ComponentProps<"video"> {
    imagePlaceholder?: string;
    imagePlaceholderAlt?: string;
    imagePlaceholderWidth?: number;
    imagePlaceholderHeight?: number;
}

const InplaceVideo = React.forwardRef<HTMLVideoElement, InplaceVideoProps>((props, ref) => {
    // Was framer-motion's useInView(..., { once: true }) used purely as a lazy-load gate (show a
    // placeholder image until scrolled into view, then mount the <video>). useReveal(true) gives the
    // same once-true in-view boolean with zero animation-library JS.
    const { ref: containerRef, shown: wasInView } = useReveal<HTMLDivElement>(true);


    const extraProps: React.ComponentProps<"video"> =
        {
            ["playsInline" as string]: true,
        };

    if (props.imagePlaceholder) {
        return (<div ref={containerRef}>
            {!wasInView && <VadImage src={props.imagePlaceholder} alt={props.imagePlaceholderAlt ?? ''}
                                     width={props.imagePlaceholderWidth} height={props.imagePlaceholderHeight}/>}
            {wasInView && <video ref={ref} {...extraProps} {...props} />}
        </div>)
    }

    return <video ref={ref} {...extraProps} {...props} />;
});

InplaceVideo.displayName = "InplaceVideo";

export {InplaceVideo};
